export const CONSTANTS = {
  PERMISSIONS: {
    CONTRACTS: 'contratos',
    INSTALMENTS: 'parcelas',
    AGREEMENTS: 'acordos',
    USERS: 'usuarios',
    PROFILES: 'perfis'
  }
};
